module.exports = __webpack_public_path__ + "static/media/05 - Ride.a4fc2d15.wav";